import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import {
  switchMap,
  tap,
  debounceTime,
  finalize,
  distinctUntilChanged,
} from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { LoadingService } from "src/app/utils/loading/loading.service";
import { BehaviorSubject } from "rxjs";
import { AcordarUtils } from "src/app/utils/acordar/utils.acordar";
import { ProvincesSvgService } from "src/app/services/provinces-svg.service";
import { AcordarService } from "src/app/services/acordar.service";

@Component({
  selector: "app-listado-provincia",
  templateUrl: "./listado-provincia.component.html",
  styleUrls: ["./listado-provincia.component.scss"],
})
export class ListadoProvinciaComponent implements OnInit {
  cargandoBusqueda = false;
  busquedaControl = new FormControl(null);
  filterProvControl = new FormControl(null);
  filterProdControl = new FormControl(null);
  filterCodControl = new FormControl(null);
  filterSolicitudControl = new FormControl(null);
  idProvincia: any;
  ofertasProvincia: BehaviorSubject<any> = new BehaviorSubject([]);
  paginaActual = 1;
  cantidadPaginas: number;
  imagenModal: any;
  descripcionProducto: any;
  cargaInicial: boolean = true;

  //pagination
  pagination: Array<number>;
  currentPage: number;
  lastPage: number;
  params: any = [];
  subscription: any;
  optsProvs: any;
  showCross: boolean = false;

  showMasInfo: any = null;
  provInhabilitado: any = null;

  constructor(
    private acordarService: AcordarService,
    private _route: ActivatedRoute,
    private loadingService: LoadingService,
    private getProvs: ProvincesSvgService
  ) {}

  ngOnInit() {
    this.optsProvs = this.getProvs.provinces_svg
      .map((prov) => prov)
      .sort((a, b) => AcordarUtils.orderAlphabetically(a.gid, b.gid));
    this._route.paramMap
      .pipe(
        tap((params: ParamMap) => {
          this.idProvincia = params.get("id_provincia");
          if (this.idProvincia !== null) {
            this.params.push({
              nombre: "ubicacion.provincia.nombre_normalizado",
              value: this.idProvincia,
            });
            this.showCross = true;
          }
          this.loadingService.show();
        }),
        switchMap(() =>
          this.acordarService
            .getBuscarSolicitud(1, this.params)
            .pipe(finalize(() => this.loadingService.hide()))
        )
      )
      .subscribe((response: any) => {
        if (response.result.length > 0) {
          this.cargaInicial = false;
        }

        this.ofertasProvincia.next(this.mapResults(response.result));
        console.log(response);
        this.paginate(response);
      });
    this.busquedaSubscription();
  }

  mapResults(acuerdos) {
    // acuerdos.map((acuerdo) => {
    // 	if (acuerdo.ubicacion) {
    // 		acuerdo.ubicacion.provincia = this.toUpper(
    // 			AcordarUtils.mapProv(acuerdo.ubicacion.provincia.nombre, this.optsProvs)
    // 		);
    // 	}
    // });
    return acuerdos;
  }

  toUpper(str) {
    return AcordarUtils.capitalizeLetter(str);
  }

  selectedProv(prov) {
    return AcordarUtils.selectProv(prov, this.idProvincia);
  }

  busquedaSubscription() {
    this.filterProvControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((response: any) => {
        let rta = response;
        this.optsProvs.map((opt) => {
          if (opt.gid === response.toUpperCase()) {
            return (rta = opt.gidBack);
          }
        });
        this.toggleCross(rta);
        this.params = AcordarUtils.evaluate(
          "ubicacion.provincia.nombre_normalizado",
          rta,
          this.params
        );
        this.handleSearch(this.params);
      });
    this.filterProdControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((response: any) => {
        this.params = AcordarUtils.evaluate(
          "producto-ean-catalogo",
          response,
          this.params
        );
        this.handleSearch(this.params);
      });
    // this.filterCodControl.valueChanges
    // 	.pipe(debounceTime(500), distinctUntilChanged())
    // 	.subscribe((response: any) => {
    // 		this.params = AcordarUtils.evaluate('producto.codigo_catalogo', response, this.params);
    // 		this.handleSearch(this.params);
    // 	});
    this.filterSolicitudControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((response: any) => {
        this.params = AcordarUtils.evaluate(
          "acuerdo-objeto",
          response,
          this.params
        );
        this.handleSearch(this.params);
      });
  }

  toggleCross(response) {
    if (response.length > 0 && response !== "empty") {
      this.showCross = true;
    } else {
      this.showCross = false;
      this.filterProvControl.setValue("empty");
    }
  }

  callService(page, params) {
    this.acordarService.getBuscarSolicitud(page, params).subscribe((rta) => {
      this.ofertasProvincia.next(this.mapResults(rta.result));
      this.pagination = AcordarUtils.createPaginationArray(rta.paged.max_paged);
      this.currentPage = page;
      this.loadingService.hide();
    });
  }

  handlePagination(page: number) {
    this.loadingService.show();
    this.ofertasProvincia.next([]);
    this.callService(page, this.params);
  }

  handleSearch(params) {
    this.loadingService.show();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.acordarService
      .getBuscarSolicitud(1, this.params)
      .subscribe(
        (response: any) => {
          this.loadingService.hide();
          this.ofertasProvincia.next(this.mapResults(response.result));
          this.paginate(response);
        },
        (error) => {
          this.loadingService.hide();
          this.ofertasProvincia.next([]);
        }
      );
  }

  paginate(response) {
    this.lastPage = response.paged.max_paged;
    this.pagination = AcordarUtils.createPaginationArray(
      response.paged.max_paged
    );
    this.currentPage = 1;
  }

  handleShowInfo(cuit) {
    if (this.showMasInfo === cuit) {
      this.showMasInfo = null;
    } else {
      this.showMasInfo = cuit;
    }
  }

  nextPage() {
    this.loadingService.show();
    let nextPage = this.currentPage + 1;
    this.ofertasProvincia.next([]);
    this.callService(nextPage, this.params);
  }

  previousPage() {
    this.loadingService.show();
    let previousPage = this.currentPage - 1;
    this.ofertasProvincia.next([]);
    this.callService(previousPage, this.params);
  }

  handleInhabilitado(cuit) {
    if (this.provInhabilitado === cuit) {
      this.provInhabilitado = null;
    } else {
      this.provInhabilitado = cuit;
      // console.log(cuit)
    }
  }
}
